import $ from "jquery";
import "slick-carousel";

export default class Carousels {
	constructor(){
		this.carousel = {
			test: document.getElementById('carousel-test'),
			young_space_gallery: document.querySelector('.carousel[data-carousel="young-space-gallery"]'),
		};
	}

	init() {
		if(this.carousel.test) { this.carousel(); }
		if(this.carousel.young_space_gallery) { this.youngSpaceGallery(); }
		console.log('Carousel.js - It works!');
	}

	carousel = () => {
		console.log('Carousel.js - It works!');
	}
	youngSpaceGallery = () => {
		var carousel = $('.carousel[data-carousel="young-space-gallery"]');
        console.log('Carousel.js - It works!');
        carousel.each(function(){
            
            $(this).not('.slick-initialized').slick({
                mobileFirst: true,
				arrows: false,
				dots:true,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                autoplay: true,
                adaptiveHeight: true,        
            });
        })
    }
}
